export default function handleError(error) {
  if (!error) {
    return 'unhandled error';
  }

  /*
   * The request was made and the server responded with a
   * status code that falls out of the range of 2xx
   */
  if (error.response && error.response.data) {
    return error.response.data;
  }

  /*
   * The request was made but no response was received, `error.request`
   * is an instance of XMLHttpRequest in the browser and an instance
   * of http.ClientRequest in Node.js
   */
  if (error.request) {
    return error.request;
  }

  // Something happened in setting up the request and triggered an Error
  if (error.message) {
    return error.message;
  }

  return error;
}
